var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAddEditModalActive)?_c('approved-evaluation-modal',{attrs:{"table-id":_vm.tableId,"selected-url":_vm.selectedUrl},on:{"close-modal":_vm.closeAddEditModal}}):_vm._e(),_vm._v(" "),_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options},on:{"action":_vm.getListAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }